import cls from "./customInnerPage.module.scss";
import {CustomSelectArrow} from "../../../svg";
import React, {Dispatch, FC, ReactNode, RefObject, SetStateAction} from "react";

interface ICustomProducts {
    productOptions?: Array<{
        id: number,
        title: string,
        product_id: number,
        required: string,
        type: string,
        children: {
            id: number,
            label: string,
            admin_name: string,
            price: number | string,
            sort_order: string | number
        }
    }>;
    optionIdShowToggle: (elemId: number, elemTitle: string) => ReactNode;
    rootRef: RefObject<HTMLDivElement> | null;
    setOpen: Dispatch<SetStateAction<boolean>>;
    arrowClassName: string;
    dropdownDisplay: string;
    toggleOptionValue: (id: number, label: string, price: string, optionId: number) => void
}

const CustomProductOptions: FC<ICustomProducts> = (
    {
        productOptions,
        optionIdShowToggle,
        rootRef,
        setOpen,
        arrowClassName,
        dropdownDisplay,
        toggleOptionValue
    }
) => {

    return (
        <div className={cls["configurable-attributes"]}>
            {productOptions?.map((element: any) => (
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}} key={element.id}>
                    <p>{`${element.title}:`}</p>
                    <div className={cls.option_dropdown_btn} style={{width: "220px"}} ref={rootRef}>
                        <article>
                            <div className={cls["wr_dropDown_name"]} onClick={() => setOpen((prevState) => !prevState)}>
                                {optionIdShowToggle(element.id, element.title)}
                                <CustomSelectArrow className={`${cls.drop_down_arrow} ${cls[arrowClassName]}`}/>
                            </div>
                            <div style={{display: dropdownDisplay}} className={cls.option_dropdown}>
                                <div className={cls["other-list-main-fms"]}>
                                    {element.children?.map((
                                        itemEL: {
                                            admin_name: string;
                                            label: string;
                                            price: string;
                                            id: number
                                        },
                                        index: number
                                    ) => (
                                        <div
                                            className={cls.option_dropdown_value}
                                            key={index}
                                            onClick={() => {
                                                toggleOptionValue(element.id, itemEL.label, itemEL.price, itemEL.id);
                                                setOpen(false)
                                            }}
                                        >
                                            <label htmlFor={itemEL?.admin_name}>{itemEL.label}</label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </article>
                    </div>
                </div>
            ))}
        </div>
    )
};

export default CustomProductOptions
